import { Button, Stack, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from '@work4all/components';

import { InviteButton } from '../../../mask-overlays/mask-overlay/views/appointment/components/invite-button/InviteButton';

interface AppointmentInviteDialogProps {
  onClose: (value: boolean) => void;
}

export const AppointmentInviteDialog = (
  props: AppointmentInviteDialogProps
) => {
  const { onClose } = props;

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleConfirm = useCallback(() => {
    setLoading(true);
    onClose(true);
  }, [onClose]);

  const handleCancel = useCallback(() => {
    setLoading(true);
    onClose(false);
  }, [onClose]);

  return (
    <Dialog
      title={t('APPOINTMENT.INVITE_DIALOG.TITLE')}
      open={true}
      closeButton={false}
    >
      <Stack padding="1rem" gap="1rem">
        <Typography>{t('APPOINTMENT.INVITE_DIALOG.DESCRIPTION')}</Typography>
        <Stack direction="row" alignItems="flex-end">
          <InviteButton onClick={handleConfirm} disabled={loading} />
          <Button style={{ flex: 1 }} onClick={handleCancel} disabled={loading}>
            {t('APPOINTMENT.INVITE_DIALOG.CANCEL')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};
